import isCompanyBenefit from "@irati/deals/helpers/deals/isCompanyBenefit"
import {Deal, PaymentCurrencyType} from "@irati/types"
import isRewards from "./isRewards"

export enum LOCAL_ID {
  FLEXIPERK = "FLEXIPERK",
  SELECT_PERK = "SELECT_PERK",
  PAID_PERK = "PAID_PERK",
  UNPAID_PERK = "UNPAID_PERK",
  REWARD = "REWARD",
  COMPANY_BENEFIT = "COMPANY_BENEFIT"
}

function getDealCtaLocal(deal: Deal) {
  if (isRewards(deal)) {
    return LOCAL_ID.REWARD
  }
  if (isCompanyBenefit(deal)) {
    return LOCAL_ID.COMPANY_BENEFIT
  }

  const {products} = deal.productConfig!
  const [dealCurrency] = products
  const flexiPerk = dealCurrency?.salePrice?.currency === PaymentCurrencyType.Tt && LOCAL_ID.FLEXIPERK
  const paidPerk = !flexiPerk && dealCurrency?.salePrice?.value && LOCAL_ID.PAID_PERK
  const selectPerk = paidPerk && products.length > 1 && LOCAL_ID.SELECT_PERK

  return flexiPerk || selectPerk || paidPerk || LOCAL_ID.UNPAID_PERK
}

export default getDealCtaLocal
